import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

    private apiURL = environment.appApiUrl + "message/";

    constructor(private http: HttpClient) { }

    open(ref: string): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + 'open/' + ref);
    }

    send(values: any) : Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + 'send', values);
    }

    respond(values: any, ref: string) : Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + "respond/" + ref, values);
    }

    downloadAttachment(filename: string, ref: string): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + 'download/' + ref + '/' + filename);
    }

    delete(values: any): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + 'delete', values);
    }

    restore(values: any): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + 'restore', values);
    }

    move(folderID: number, values: any): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + 'moveTo/' + folderID, values);
    }

    reSendByPatient(patientUserID: string): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + 'resend/patient/' + patientUserID, null);
    }

    reSend(messageID: number): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + 'resend', messageID);
    }

    reSendSelectMessages(messages: any): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + 'resend/messages', messages);
    }

} 